import {axios, createAsyncThunk} from '../thunk-config'

export default createAsyncThunk('payment/generateTestPaymentInfo', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get('/demo/test_customer')

    return response.data
  } catch(err) {
    if(!err.response) {
      throw err
    }

    return rejectWithValue(err.response.data)
  }
})


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunks/generateTestPaymentInfo.js